<template>
  <div class="w-550px m-auto">
    <el-form :model="form" :rules="formRules" ref="formRef">
      <el-form-item label="版本号" prop="version">
        <el-input
          v-model="form.version"
          placeholder="请填写版本号"
          show-word-limit
          :maxlength="30"
        ></el-input>
      </el-form-item>
      <el-form-item label="版本来源" prop="origin">
        <el-radio
          v-for="item in originRadio"
          :key="item.value"
          v-model="form.origin"
          :label="item.value"
          @change="originChange"
          >{{ item.label }}</el-radio
        >
      </el-form-item>
      <el-form-item label=" " prop="originValue">
        <el-select
          v-model="form.originValue"
          v-if="form.origin === 0"
          placeholder="请选择分支"
          @change="branchChange"
        >
          <el-option
            v-for="item in branchs"
            :label="item.name"
            :value="item.id"
            :key="item.id"
          ></el-option
        ></el-select>
        <el-input
          v-if="form.origin === 1"
          placeholder="请输入commit id"
          v-model="form.originName"
        >
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    const checkOriginValue = (rule, value, callback) => {
      if (!value) {
        if (this.form.origin === 0) {
          callback(new Error('请选择分支'))
        } else if (this.form.origin === 1) {
          callback(new Error('请填写commit id'))
        }
      } else {
        callback()
      }
    }
    return {
      form: {
        origin: 0,
        originValue: '',
        originName: ''
      },
      originRadio: [
        { label: '分支', value: 0 }
        // { label: 'commit id', value: 1 } // 需求讨论后决定删除
      ],
      formRules: {
        version: [
          { required: true, message: '请填写版本号', trigger: 'change' }
        ]
        // origin: [
        //   { required: true, message: '请选择版本来源', trigger: 'change' }
        // ],
        // originValue: [{ validator: checkOriginValue, trigger: 'change' }]
      }
    }
  },
  computed: {
    branchs() {
      return this.$store.state.project.branchs
    }
  },
  created() {},
  mounted() {},
  methods: {
    originChange() {
      if (!this.form.originValue) {
        this.$refs['formRef'].validateField('originValue')
      }
    },
    branchChange(val) {
      let res = this.branchs.find((item) => item.id === val)
      this.form.originName = res.name
    },
    finish() {
      return new Promise((resolve, reject) => {
        try {
          this.$refs['formRef'].validate((valid) => {
            if (valid) {
              resolve(this.form)
            } else {
              reject()
            }
          })
        } catch (error) {
          reject(error)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
